export enum UserTypeEnums {
  ABO = 'ABO',
}
